export enum PersonType {
  INDIVIDUAL = 'INDIVIDUAL',
  CORPORATION = 'CORPORATION'
}
